import { useEffect, useState } from 'react';
import api from '../services/api';

let cache = null;
let fetchPromise = null;

async function fetchAllVideos() {
  if (fetchPromise) return fetchPromise;
  fetchPromise = api
    .get('tutorial-video/listar')
    .then((res) => {
      cache = {};
      res.data.forEach((item) => {
        cache[item.Tela] = item.Url || null;
      });
      return cache;
    })
    .catch(() => {
      fetchPromise = null;
      cache = {};
      return cache;
    });
  return fetchPromise;
}

export function useTutorialVideo(tela) {
  const [url, setUrl] = useState(() => (cache ? cache[tela] ?? null : undefined));

  useEffect(() => {
    if (cache) {
      setUrl(cache[tela] ?? null);
      return;
    }
    fetchAllVideos().then((data) => setUrl(data[tela] ?? null));
  }, [tela]);

  return url;
}
